'use strict';

export function Modal(params) {

    const element = (function () {
        let element = null;

        if (document.getElementsByClassName('modal').length > 0) {
            element = document.getElementsByClassName('modal')[0];
            const wrapper = element.getElementsByClassName('modal__wrapper')[0];

            if (!!wrapper) {
                if (!!params && params.isLarger && !wrapper.classList.contains('modal__wrapper--larger')) {
                    wrapper.classList.add('modal__wrapper--larger');
                } else if (wrapper.classList.contains('modal__wrapper--larger')) {
                    wrapper.classList.remove('modal__wrapper--larger');
                }

                if (!!params && params.isAlignCenter && !element.classList.contains('modal--vertically-centered')) {
                    element.classList.add('modal--vertically-centered');
                } else if (element.classList.contains('modal--vertically-centered')) {
                    element.classList.remove('modal--vertically-centered');
                }
            }
        } else {
            element = document.createElement('div');
            element.classList.add('modal');

            if (!!params && params.isAlignCenter) element.classList.add('modal--vertically-centered');
            const wrapperModifier = !!params && params.isLarger ? ' modal__wrapper--larger' : '';
            const closeSymbol =  typeof CLOSEMODALSYMBOL !== 'undefined' ? CLOSEMODALSYMBOL : '✖';

            element.innerHTML = '<div class="modal__wrapper' + wrapperModifier + '" role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description"> \
                    <button class="modal__close-cta">' + closeSymbol + '</button> \
                    <div class="modal__content"></div> \
                </div>';
        }

        return element;
    })();

    function updateStyles(params) {
        const wrapper = element.getElementsByClassName('modal__wrapper')[0];

        if (!!params && params.isLarger && !wrapper.classList.contains('modal__wrapper--larger')) {
            wrapper.classList.add('modal__wrapper--larger');
        } else if ((!params || !params.isLarger) && wrapper.classList.contains('modal__wrapper--larger')) {
            wrapper.classList.remove('modal__wrapper--larger');
        }

        if (!!params && params.isAlignCenter && !element.classList.contains('modal--vertically-centered')) {
            element.classList.add('modal--vertically-centered');
        } else if ((!params || !params.isAlignCenter) && element.classList.contains('modal--vertically-centered')) {
            element.classList.remove('modal--vertically-centered');
        }
    }

    function init() {
        const _this = this;
        document.body.appendChild(_this.element);
        _this.element.style.display = 'none';

        const modalCloseCTAElements = _this.element.querySelectorAll('.modal__close-cta');
        for (let i = 0; i < modalCloseCTAElements.length; ++i) {
            modalCloseCTAElements[i].addEventListener('click', function (event) {
                event.preventDefault();
                _this.hide();
            });
        }

        element.addEventListener('click', function (event) {
            if (event.target === _this.element) {
                _this.hide();
            }
        });
    }

    function clearContent(wrapperElement) {
        if (wrapperElement.hasChildNodes()) {
            while (wrapperElement.firstChild) {
                wrapperElement.removeChild(wrapperElement.firstChild);
            }
        }
    }

    function show(content, callback) {
        const _this = this;

        const modalContentWrapperElement = _this.element.querySelector('.modal__content');
        clearContent(modalContentWrapperElement); // TODO: avoid clearContent here

        const contentWrapperElement = document.createElement('div');
        contentWrapperElement.classList.add('post');
        contentWrapperElement.innerHTML = content;
        modalContentWrapperElement.appendChild(contentWrapperElement);

        if (callback && typeof callback === 'function') callback();

        const modalCloseCTAElements = _this.element.querySelectorAll('.modal__close-cta');
        for (let i = 0; i < modalCloseCTAElements.length; ++i) {
            modalCloseCTAElements[i].setAttribute('tabindex', '1');
        }

        _this.element.removeAttribute('style');
        _this.element.classList.add('modal--visible');

        window.setTimeout(function () {
            document.body.style.overflow = 'hidden';
        }, 500);
    }

    function hide() {
        const _this = this;

        _this.element.classList.remove('modal--visible');

        window.setTimeout(function () {
            _this.element.style.display = 'none';
            document.body.style.removeProperty('overflow');

            const modalCloseCTAElements = _this.element.querySelectorAll('.modal__close-cta');
            for (let i = 0; i < modalCloseCTAElements.length; ++i) {
                modalCloseCTAElements[i].setAttribute('tabindex', '0');
            }

            clearContent(_this.element.querySelector('.modal__content'));
        }, 500);
    }

    /* TODO: don't expose element and init */
    return {
        element: element,
        init: init,
        show: show,
        hide: hide,
        updateStyles: updateStyles
    }
}
